import React, { useState } from 'react';
import './TopBar.css';

function TopBar({ user, onLogout, onOpenPalette }) {
    const [showDropdown, setShowDropdown] = useState(false);

    const handleSwitchRegion = () => {
        // Clear API URL and env/region from storage to force re-selection on login page
        localStorage.removeItem('api_base_url');
        localStorage.removeItem('birt_environment');
        localStorage.removeItem('birt_region');
        // Logout user
        onLogout();
    };

    return (
        <div className="topbar">
            <div className="topbar-spacer"></div>
            <button className="topbar-search" onClick={onOpenPalette}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <span>Search...</span>
              <kbd>⌘K</kbd>
            </button>
            <div className="topbar-user" onClick={() => setShowDropdown(!showDropdown)}>
                <div className="user-info">
                    <span className="username">{user.username}</span>
                    <span className="user-role">Admin</span>
                </div>
                <div className="user-avatar">
                    {user.username.charAt(0).toUpperCase()}
                </div>

                {showDropdown && (
                    <div className="user-dropdown">
                        <button onClick={handleSwitchRegion} className="dropdown-item">
                            <span className="icon">🔄</span> Switch Region
                        </button>
                        <button onClick={onLogout} className="dropdown-item text-danger">
                            <span className="icon">🚪</span> Logout
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default TopBar;
